export const availableIcons = [
  { id: 'user', name: 'User', icon: '👤' },
  { id: 'star', name: 'Star', icon: '⭐' },
  { id: 'music', name: 'Music', icon: '🎵' },
  { id: 'camera', name: 'Camera', icon: '📸' },
  { id: 'rocket', name: 'Rocket', icon: '🚀' },
  { id: 'heart', name: 'Heart', icon: '❤️' },
  { id: 'crown', name: 'Crown', icon: '👑' },
  { id: 'lightning', name: 'Lightning', icon: '⚡' },
  { id: 'flower', name: 'Flower', icon: '🌸' },
  { id: 'diamond', name: 'Diamond', icon: '💎' },
  { id: 'fire', name: 'Fire', icon: '🔥' },
  { id: 'butterfly', name: 'Butterfly', icon: '🦋' },
  { id: 'rainbow', name: 'Rainbow', icon: '🌈' },
  { id: 'moon', name: 'Moon', icon: '🌙' },
  { id: 'sun', name: 'Sun', icon: '☀️' },
  { id: 'planet', name: 'Planet', icon: '🪐' }
]

export const getIconById = (iconId) => {
  return availableIcons.find(icon => icon.id === iconId) || availableIcons[0]
}